import React, { useContext } from "react";
import { BlockStack, Button, InlineStack, Box, Card, Text } from "@shopify/polaris";

// import propTypes
import propType from "prop-types";

// import helpers
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";

const CardList = (props) => {
  const { cms, currentUser } = useContext(PrivateContext);
  const { handleClick, isMuted, isLoadingLabel, labelData, seller = {}, vendor = {} } = props;
  const isSeller = baseHelper.isSeller(currentUser);
  const isVendor = baseHelper.isVendor(currentUser);
  let labelsList = isSeller && seller;
  if (isVendor) {
    labelsList = isVendor && vendor;
  }
  return (
    <Card>
      <InlineStack wrap={false} blockAlign="center" align="space-between">
        <Text as="p">{labelsList[labelData]}</Text>
        <Button
          role="switch"
          size="slim"
          key="settingToggle"
          disabled={false}
          loading={isLoadingLabel}
          variant="primary"
          tone={!isMuted ? "critical" : ""}
          // tone="success"
          ariaChecked={!isMuted}
          onClick={() => handleClick(labelData)}
        >
          {(isMuted && `${cms("button.unMute")}`) || baseHelper.ucFirst(`${cms("button.mute")}`)}
        </Button>
      </InlineStack>
    </Card>
  );
};

CardList.defaultProps = propType.default;
CardList.propTypes = propType.type;

export default CardList;
